"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const button_1 = __importDefault(require("@kyruus/button"));
const intl_1 = require("@kyruus/intl");
const react_1 = require("@xstate/react");
const react_2 = __importDefault(require("react"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const utils_1 = require("../../../lib/utils");
const constants_1 = require("../../lib/constants");
const messages_1 = __importDefault(require("../../lib/messages"));
const configs_1 = require("../../lib/constants/configs");
const styles_1 = require("./styles");
const useManageAppointmentContext_1 = require("../../hooks/useManageAppointmentContext");
const Tracking_1 = require("../../lib/constants/Tracking");
/**
 * SelectAction component
 *
 * @component
 *
 * @param {SelectActionProps} param0 Main machine service object
 * @returns {React.Component} SelectAction component
 */
const SelectAction = ({ service }) => {
    const [state, send] = (0, react_1.useService)(service);
    const { appointment, capabilities, provider } = state.context;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const formattedAppointmentDate = (0, utils_1.getAppointmentDate)({ start_datetime: appointment === null || appointment === void 0 ? void 0 : appointment.start_datetime }, 'MMMM DD, YYYY');
    const handleCancelAppointment = () => {
        track(Tracking_1.userEvents.CANCEL_APPOINTMENT_CLICKED);
        window.location.assign(`${configs_1.CANCEL_ROUTE}/${appointment === null || appointment === void 0 ? void 0 : appointment.id}`);
    };
    const handleRescheduleAppointment = () => {
        track(Tracking_1.userEvents.RESCHEDULE_APPOINTMENT_CLICKED);
        send(constants_1.events.RESCHEDULE);
    };
    const providerName = (0, utils_1.makeNameString)({
        first: provider.name.first,
        last: provider.name.last,
        middle: provider.name.middle
    });
    return (react_2.default.createElement(styles_1.StyledSelectActionContainer, { "data-testid": "select-action-component" },
        react_2.default.createElement(styles_1.StyledInfoMessage, null,
            react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.selectActionMessage, { values: {
                    provider_name: providerName,
                    appointment_time: `${formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedDate} at ${formattedAppointmentDate.formattedTime}`
                } }))),
        react_2.default.createElement(styles_1.StyledButtonGroup, { isDesktop: aboveMd },
            (capabilities === null || capabilities === void 0 ? void 0 : capabilities.isCancelEnabled) && (react_2.default.createElement(button_1.default, { mode: "ghost", onClick: handleCancelAppointment, "data-testid": "cancel-appointment-button" },
                react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.cancelAppointment)))),
            (capabilities === null || capabilities === void 0 ? void 0 : capabilities.isRescheduleEnabled) && (react_2.default.createElement(button_1.default, { mode: "primary", onClick: handleRescheduleAppointment, "data-testid": "reschedule-appointment-button" },
                react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.rescheduleAppointment)))))));
};
exports.default = SelectAction;
//# sourceMappingURL=SelectAction.js.map